var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 16.0003C18.744 16.0003 18.488 15.9023 18.293 15.7073L12 9.41434L5.70707 15.7073C5.31607 16.0983 4.68401 16.0983 4.29301 15.7073C3.90201 15.3163 3.90201 14.6842 4.29301 14.2933L11.293 7.29325C11.684 6.90225 12.3161 6.90225 12.7071 7.29325L19.7071 14.2933C20.0981 14.6842 20.0981 15.3163 19.7071 15.7073C19.5121 15.9023 19.256 16.0003 19 16.0003Z",
    fill: "#777E90"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrowUp.ce1cc29448d2df547e1dd91caf65bbab.svg";
export { ForwardRef as ReactComponent };